import { ReactElement, useState } from "react";
import PlayButtonIcon from "../../shared-components/icons/PlayButtonIcon";
import FormTwoColumnContainer from "../../shared-components/FormTwoColumnContainer";
import { Link } from "react-router-dom";
import { Modal } from "../../shared-components/Modal";

const UploadInstructions = () => {
  const [showModal, setShowModal] = useState(false);
  function close() {
    setShowModal(false);
  }
  interface TableRow {
    columnName: string;
    required: string;
    acceptedValue: string;
  }
  const header: ReactElement[] = [
    <th className="w-1/6" key="th1">
      Column Name
    </th>,
    <th className="w-1/6" key="th2">
      Is this field Required?
    </th>,
    <th className="w-3/6" key="th3">
      Accepted Value
    </th>,
  ];
  const tableRows: TableRow[] = [
    {
      columnName: "First Name",
      required: "Yes",
      acceptedValue: "One name, no special characters or accents",
    },
    {
      columnName: "Middle Name",
      required: "No",
      acceptedValue: "One name, no special characters or accents",
    },
    {
      columnName: "Last Name",
      required: "Yes",
      acceptedValue: "One name, no special characters or accents",
    },
    {
      columnName: "Email Addresses",
      required: "Yes",
      acceptedValue: "One Email address, no special characters or accents",
    },
    {
      columnName: "Phone Numbers",
      required: "No",
      acceptedValue:
        "Enter one phone number, only numbers. No spaces, dashes, or commas.",
    },
    {
      columnName: "Locations",
      required: "No",
      acceptedValue:
        "Enter all known City, State of residence all spelled out. Separate each city and state with a pipe (|) and each new location with a semicolon (;). No quotes, semicolons or commas within values.\n\nEx: Los Angeles|California;Chicago;Texas;Orlando;Greenbay|Wisconsin",
    },
    {
      columnName: "Employers",
      required: "No",
      acceptedValue:
        "Enter all known past employers. Separate each company name then title with a pipe (|), in that order. Separate each new job or company with a semicolon (;). No quotes, semicolons or commas within values.\n\nEx: Best Buy|Sales Associate;Amazon|Sales Manager;Procter & Gamble;Apple|Customer Service Agent",
    },
    {
      columnName: "Degrees",
      required: "No",
      acceptedValue:
        "Enter all known education history. Separate each school then degree with a pipe (|), in that order. Separate each new degree or school with a semicolon (;). No quotes, semicolons or commas within values.\n\nEx: Bachelor in Economics;University of Town|BS in Computer Science;Cal State University of Fullerton",
    },
    {
      columnName: "Aliases",
      required: "No",
      acceptedValue:
        "Enter all known aliases. Separate each new alias with a semicolon (;).\n\nEx: Jane Fama;Jane Smith;Jan Smith",
    },
    {
      columnName: "Client Reference ID",
      required: "No",
      acceptedValue:
        "Enter any reference values like account numbers or Client side ID",
    },
    {
      columnName: "Social Profiles",
      required: "No",
      acceptedValue:
        "Enter all known social media profiles separated by a semicolon (;)\n\nEx: https://www.twitter.com/user;https://www.facebook.com/user123",
    },
    {
      columnName: "Date of Birth",
      required: "No",
      acceptedValue:
        "Enter date of birth as MM/DD/YYYY or YYYY-MM-DD format\n\nex:04/25/1987 or 1987-04-25",
    },
  ];
  return (
    <>
      <FormTwoColumnContainer title="Instructions" className="mb-14">
        <div className="mb-4">
          <strong>Template Instructions</strong>
        </div>
        <div>
          <ul className="space-y-4">
            <li className="flex mb-4">
              <div className="my-auto">
                <PlayButtonIcon className="h-8 w-8 pt-1" />
              </div>
              <div className="text-sm font-medium text-gray-600">
                Please make sure you use the provided template and refer to
                <Link
                  onClick={() => setShowModal(true)}
                  to={""}
                  className="text-[#46c8f4] mx-1"
                >
                  {"this document"}
                </Link>
                for accepted format for each column.
              </div>
            </li>
            <li className="flex">
              <div className="my-auto">
                <PlayButtonIcon className="h-8 w-8 pt-1" />
              </div>
              <div className="text-sm font-medium text-gray-600">
                All data value <strong>MUST</strong> be in correct format or
                report(s) will fail to create.
              </div>
            </li>
            <li className="flex">
              <div className="my-auto">
                <PlayButtonIcon className="h-8 w-8 pt-1" />
              </div>
              <div className="text-sm font-medium text-gray-600">
                All profile URLs must include http:// or https:// (Example:
                https://x.com/home).
              </div>
            </li>
            <li className="flex mt-6">
              <div className="my-auto">
                <PlayButtonIcon className="h-8 w-8 pt-1" />
              </div>
              <div className="text-sm font-medium text-gray-600">
                Commas (,), quotes ("), and apostrophes (') are forbidden. They
                must be <strong>REMOVED</strong> from every cell in the file to
                prevent error.
              </div>
            </li>
          </ul>
        </div>
      </FormTwoColumnContainer>
      <Modal open={showModal} onClose={close} width={"w-full max-w-6xl p-4"}>
        <table className="table-fixed border-collapse border border-slate-500">
          <thead>
            <tr className="bg-[#cfe2f3]">{header.map((thead) => thead)}</tr>
          </thead>
          <tbody>
            {tableRows.map((tRow) => {
              return (
                <tr
                  className="border border-slate-700"
                  key={"th-UpInst-" + tRow.columnName}
                >
                  <td>{tRow.columnName}</td>
                  <td className="flex justify-center pr-10">{tRow.required}</td>
                  <td>{tRow.acceptedValue}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Modal>
    </>
  );
};

export default UploadInstructions;
